/* ══════════════════════════════════════════════════════════
   JUST ONE MORE — Motion System v1.0
   IntersectionObserver scroll reveal. No dependencies.
   ══════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  if (typeof IntersectionObserver === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var STAGGER_MS  = 88;
  var STAGGER_MAX = 5;
  var isMobile    = window.matchMedia('(max-width: 749px)').matches;

  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, {
    threshold: 0.07,
    rootMargin: '0px 0px -52px 0px'
  });

  function reveal(el, variant, delay) {
    if (el.classList.contains('jom-reveal')) return;
    el.classList.add('jom-reveal', 'jom-reveal--' + variant);
    if (delay) el.style.setProperty('--jom-delay', delay + 'ms');
    observer.observe(el);
  }

  function stagger(container, selector, variant) {
    var ms = isMobile ? 44 : STAGGER_MS;
    container.querySelectorAll(selector).forEach(function (el, i) {
      reveal(el, variant, Math.min(i, STAGGER_MAX) * ms);
    });
  }

  function applyReveal() {
    /* Section headers */
    document.querySelectorAll(
      '.section-header__title, .section-header__description, ' +
      '.collection-header__title, .collection-description, .collection-header__description'
    ).forEach(function (el) { reveal(el, 'up', 0); });

    /* Rich text */
    document.querySelectorAll('.rich-text__heading').forEach(function (el) {
      reveal(el, 'up', 0);
    });
    document.querySelectorAll('.rich-text__text').forEach(function (el) {
      reveal(el, 'up', 80);
    });

    /* Image with text */
    document.querySelectorAll(
      '.image-with-text__media-wrapper, .image-with-text__media'
    ).forEach(function (el) {
      reveal(el, 'fade', 0);
    });
    document.querySelectorAll('.image-with-text__heading').forEach(function (el) {
      reveal(el, 'up', 100);
    });
    document.querySelectorAll('.image-with-text__text').forEach(function (el) {
      reveal(el, 'up', 160);
    });

    /* Product cards — stagger per section */
    document.querySelectorAll('.shopify-section').forEach(function (section) {
      var cards = section.querySelectorAll('product-card');
      if (cards.length === 0) return;
      var ms = isMobile ? 44 : STAGGER_MS;
      cards.forEach(function (card, i) {
        reveal(card, 'up', Math.min(i, STAGGER_MAX) * ms);
      });
    });

    /* Resource list (collection cards) */
    document.querySelectorAll('.resource-list').forEach(function (list) {
      stagger(list, '.resource-list__item', 'scale');
    });

    /* Multicolumn */
    document.querySelectorAll('.multicolumn').forEach(function (mc) {
      stagger(mc, '.multicolumn-list__item, .icon-with-text', 'up');
    });

    /* Article cards */
    document.querySelectorAll('.article-card').forEach(function (el) {
      reveal(el, 'up', 0);
    });

    /* Newsletter */
    document.querySelectorAll('.newsletter__form, .newsletter__heading').forEach(function (el) {
      reveal(el, 'up', 0);
    });

    /* Featured collection title */
    document.querySelectorAll('.featured-collection__title, .section-header h2').forEach(function (el) {
      reveal(el, 'up', 0);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyReveal);
  } else {
    applyReveal();
  }

  /* Re-init after Horizon page transitions */
  document.addEventListener('page:load', applyReveal);
  /* Re-init after theme editor section reloads */
  document.addEventListener('shopify:section:load', applyReveal);
})();

/* ─── PHASE 11: SCROLL PROGRESS BAR ─── */
(function () {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  var bar;
  function init() {
    if (document.getElementById('jom-scroll-progress')) return;
    bar = document.createElement('div');
    bar.id = 'jom-scroll-progress';
    document.body.appendChild(bar);
    window.addEventListener('scroll', update, { passive: true });
    update();
  }
  function update() {
    if (!bar) return;
    var doc = document.documentElement;
    var total = doc.scrollHeight - doc.clientHeight;
    bar.style.width = total > 0 ? (window.scrollY / total * 100).toFixed(1) + '%' : '0%';
  }
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();
  document.addEventListener('page:load', update);
})();
